import enRaw from './en.json'
import deRaw from './de.json'

// Normalize/alias keys at load time to ensure backwards compatibility
function normalizeLocales(locale: any) {
  // Promote admin.config.database -> admin.database if missing
  if (locale?.admin) {
    const admin = locale.admin as any
    if (!admin.database && admin.config && admin.config.database) {
      admin.database = admin.config.database
    }
  }
  return locale
}

export const en = normalizeLocales(enRaw)
export const de = normalizeLocales(deRaw)

export default { en, de }
